"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("@/components/echartsNew/index"));
var _newToExcel = _interopRequireDefault(require("@/utils/newToExcel.js"));
var _statistic = require("@/api/statistic");
var _permission = require("@/utils/permission");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 权限判断函数
var _default = exports.default = {
  components: {
    echartsNew: _index.default
  },
  data: function data() {
    return {
      spinShow: false,
      grid: {
        xl: 8,
        lg: 8,
        md: 8,
        sm: 24,
        xs: 24
      },
      options: this.$timeOptions,
      name: '近30天',
      timeVal: [],
      fromList: this.$constants.timeList,
      dateLimit: '',
      dateLimitPram: {},
      list: [],
      optionData: {},
      style: {
        height: '400px'
      },
      pickerOptions: this.$timeOptions //快捷时间选项
    };
  },
  created: function created() {
    var end = new Date();
    var start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
    this.timeVal = [start, end];
  },
  mounted: function mounted() {
    this.dateLimit = 'lately7';
    this.dateLimitPram = 'lately7';
    this.getStatistics();
    this.getTrend();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    // 具体日期
    onchangeTime: function onchangeTime(e) {
      this.timeVal = e;
      this.dateLimit = e ? this.timeVal.join(',') : '';
      this.dateLimitPram = e ? this.timeVal.join(',') : '';
    },
    selectChange: function selectChange(limit) {
      if (limit == '') {
        //昨天的时间
        var day1 = new Date();
        var day2 = new Date();
        day1.setTime(day1.getTime() - 48 * 60 * 60 * 1000);
        day2.setTime(day2.getTime() - 24 * 60 * 60 * 1000);
        var s1 = day1.getFullYear() + '-' + (day1.getMonth() + 1) + '-' + day1.getDate();
        var s2 = day2.getFullYear() + '-' + (day2.getMonth() + 1) + '-' + day2.getDate();
        this.dateLimitPram = "".concat(s1, ",").concat(s2);
        this.getTrend();
        this.getStatistics();
      } else {
        this.dateLimitPram = limit;
        this.getTrend();
        this.getStatistics();
      }
    },
    onSeach: function onSeach() {
      this.getStatistics();
      this.getTrend();
    },
    exports: function () {
      var _exports = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var th, filekey, data, fileName, lebData;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              th = [], filekey = [], data = [], fileName = '';
              _context.n = 1;
              return this.getExcelData();
            case 1:
              lebData = _context.v;
              //表格主要数据
              if (!fileName) fileName = '商品统计表'; //文件名
              if (!filekey.length) {
                filekey = lebData.filekey;
              }
              if (!th.length) th = lebData.header; //表头
              data = data.concat(lebData.exportData);
              (0, _newToExcel.default)(th, filekey, fileName, data);
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function exports() {
        return _exports.apply(this, arguments);
      }
      return exports;
    }(),
    getExcelData: function getExcelData(excelData) {
      var _this = this;
      return new Promise(function (resolve, reject) {
        (0, _statistic.productTrendApi)({
          dateLimit: _this.dateLimitPram
        }).then(function (res) {
          var header = ['日期/时间', '浏览量', '新增商品数量', '收藏量', '加购件数', '下单商品数', '交易成功商品数']; //表头
          var filekey = ['date', 'pageView', 'addProductNum', 'collectNum', 'addCartNum', 'orderProductNum', 'orderSuccessProductNum']; //表头每一项对应的key
          var exportData = new Array();
          exportData = res.map(function (item) {
            return {
              date: item.date,
              pageView: item.pageView,
              addProductNum: item.addProductNum,
              collectNum: item.collectNum,
              addCartNum: item.addCartNum,
              orderProductNum: item.orderProductNum,
              orderSuccessProductNum: item.orderSuccessProductNum
            };
          });
          resolve({
            header: header,
            filekey: filekey,
            exportData: exportData
          });
        });
      });
    },
    // 统计
    getStatistics: function getStatistics() {
      var _this2 = this;
      (0, _statistic.productDataApi)({
        dateLimit: this.dateLimitPram
      }).then(function (res) {
        var list = [{
          name: '新增量',
          icon: 'iconxinzengliang',
          color: '#1890FF',
          class: 'one',
          info: '在选定条件下，新增加的商品之和',
          list: {
            num: res.newProductNum,
            percent: res.newProductNumRatio
          }
        }, {
          name: '浏览量',
          icon: 'iconliulanliang',
          color: '#A277FF',
          class: 'two',
          info: '在选定条件下，所有商品详情页被访问的次数，一个人在统计时间内访问多次记为多次',
          list: {
            num: res.pageView,
            percent: res.pageViewRatio
          }
        }, {
          name: '收藏量',
          icon: 'iconshoucangliang',
          color: '#EF9C20',
          class: 'three',
          info: '在选定条件下，被收藏的商品数量之和',
          list: {
            num: res.collectNum,
            percent: res.collectNumRatio
          }
        }, {
          name: '加购量',
          icon: 'iconjiagouliang',
          color: '#1BBE6B',
          class: 'four',
          info: '在选定条件下，添加商品进入购物车的商品件数',
          list: {
            num: res.addCartNum,
            percent: res.addCartNumRatio
          }
        }, {
          name: '交易总件数',
          icon: 'iconjiaoyijianshu',
          color: '#4BCAD5',
          class: 'five',
          info: '在选定条件下，成功下单的商品件数之和',
          list: {
            num: res.orderProductNum,
            percent: res.orderProductNumRatio
          }
        }, {
          name: '交易成功数',
          icon: 'iconjiaoyichenggongshu',
          color: '#EF9C20',
          class: 'six',
          info: '在选定条件下，交易成功的商品件数之和',
          list: {
            num: res.orderSuccessProductNum,
            percent: res.orderSuccessProductNumRatio
          }
        }];
        _this2.list = list.map(function (item) {
          return {
            name: item.name,
            icon: item.icon,
            list: item.list,
            info: item.info,
            color: item.color,
            class: item.class,
            ratio: item.list.percent.replace('%', '') / 100
          };
        });
      });
    },
    getTrend: function getTrend() {
      var _this3 = this;
      (0, _statistic.productTrendApi)({
        dateLimit: this.dateLimitPram
      }).then(function (res) {
        var xAxis = new Array();
        var series = [{
          name: '商品浏览量',
          data: [],
          type: 'line',
          smooth: 'true',
          yAxisIndex: 0
        }, {
          name: '收藏数量',
          data: [],
          type: 'line',
          smooth: 'true',
          yAxisIndex: 0
        }, {
          name: '交易总件数',
          data: [],
          type: 'line',
          smooth: 'true',
          yAxisIndex: 0
        }];
        xAxis = res.map(function (item) {
          return item.date;
        });
        series[0].data = res.map(function (item) {
          return item.pageView;
        });
        series[1].data = res.map(function (item) {
          return item.collectNum;
        });
        series[2].data = res.map(function (item) {
          return item.orderSuccessProductNum;
        });
        _this3.spinShow = true;
        var legend = series.map(function (item) {
          return item.name;
        });
        var col = ['#B37FEB', '#FFAB2B', '#1890FF', '#00C050'];
        series.map(function (item, index) {
          item.itemStyle = {
            normal: {
              color: col[index]
            }
          };
        });
        _this3.optionData = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          legend: {
            x: 'center',
            data: legend
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          toolbox: {
            feature: {
              saveAsImage: {}
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: true,
            axisLabel: {
              interval: 0,
              rotate: 40,
              textStyle: {
                color: '#000000'
              }
            },
            data: xAxis
          },
          yAxis: [{
            type: 'value',
            name: '数量',
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              textStyle: {
                color: '#7F8B9C'
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#F5F7F9'
              }
            }
          }],
          series: series
        };
        _this3.spinShow = false;
      });
    }
  }
};